import React, { useState } from 'react';
import { Chat } from 'devextreme-react/chat';
import { useParams, useNavigate } from 'react-router-dom';

export default function ChatView() {
  const { username } = useParams();
  const navigate = useNavigate();

  // Helper functions for namespaced localStorage
  const getStorage = (key) => username ? localStorage.getItem(`${username}-${key}`) : '';
  const setStorage = (key, value) => {
    if (!username) throw new Error('No username in URL');
    localStorage.setItem(`${username}-${key}`, value);
  };

  const otherPerson = {
    id: 2,
    name: getStorage('otherName') || 'Other Person',
    avatarUrl: getStorage('otherImage') || null
  };

  function getMessagesWithAvatar() {
    var messages = JSON.parse(getStorage('messages')) || [];
    const cleaned = messages.map(msg => ({
      ...msg,
      author: msg.author?.id === 2 ? otherPerson : msg.author
    }));
    console.log(cleaned);
    return cleaned;
  }

  const [messages, setMessages] = useState(getMessagesWithAvatar() || []);
  const [user] = useState({ id: 1, name: 'You' });
  const [chatTypingUsers, setChatTypingUsers] = useState([]);

  function saveMessagesWithoutAvatar(messages) {
    const cleaned = messages.map(msg => ({
      ...msg,
      author: msg.author ? { ...msg.author, avatarUrl: undefined } : msg.author
    }));
    console.log('Saving messages without avatar URLs:', cleaned);
    setStorage('messages', JSON.stringify(cleaned));
  }
  
  const handleSendMessage = async ({ message }) => {
    if (!message.text) return;

    // Add user's message to the chat
    var next = [
      ...messages,
      { text: message.text, author: { id: user.id, name: user.name }, timeStamp: new Date() },
    ];
    setMessages(next);
    saveMessagesWithoutAvatar(next);

    // Send message to OpenAI API
    const apiKey = localStorage.getItem('openaiApiKey') || '';   
    const expectedBehavior = getStorage('expectedBehavior') || '';
    const personality = getStorage('personality') || '';

    if (!apiKey) {
      console.error('API key is required');
      return;
    }

    const prompt = `You are a chat partner with the following personality: ${personality}. Answer the user's input while following the expected behaviour: ${expectedBehavior}. User's input: "${message.text}" Do not use the personality description in your answers. Limit your response to 1000 characters. Be informal, cozy and subjective. Use Gen-Z slang.`;

    const payload = {
      model: "gpt-4o",
      input: [
        {
          role: "user",
          content: [
            { type: "input_text", text: prompt },
          ],
        },
      ],
    };

    const delay = Math.floor(Math.random() * 4000) + 1000;
    await new Promise(resolve => setTimeout(resolve, delay));
    setChatTypingUsers([otherPerson]);

    try {
      const response = await fetch("https://api.openai.com/v1/responses", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${apiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || "API error occurred.");
      }

      const data = await response.json();
      const botMessage = data.output[0]?.content[0]?.text || "No response from API.";

      const delay = Math.floor(botMessage.length * 50);
      await new Promise(resolve => setTimeout(resolve, delay));

      // Add API response to the chat
      next = [
        ...next,
        { text: botMessage, author: otherPerson, timeStamp: new Date() },
      ];
      setMessages(next);
      saveMessagesWithoutAvatar(next);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setChatTypingUsers([]);
    }
  };

  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
        borderBottom: '1px solid #eee',
        background: '#fafafa',
        height: '80px'
      }}>
        <button
          type="button"
          className="btn btn-link p-0 me-3"
          style={{ fontSize: '1.5em', textDecoration: 'none' }}
          onClick={() => navigate('/chats')}
        >
          ⬅️
        </button>
        <img
          src={getStorage('otherImage') || ''}
          alt="Chat User"
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            objectFit: 'cover',
            marginRight: 16,
            border: '2px solid #ddd'
          }}
        />
        <span
          style={{ fontWeight: 'bold', fontSize: '1.2em', cursor: 'pointer' }}
          onClick={() => navigate(`/settings/${username}`)}
        >
          {getStorage('otherName') || 'Other Person'}
        </span>
      </div>
      <Chat
        height="calc(100vh - 80px)"
        user={user}
        typingUsers={chatTypingUsers}
        items={messages}
        onMessageEntered={handleSendMessage}
      />
    </div>
  );
}